import { WidgetHelper } from '@/helpers/Widget'

import CobrowseWidget from '@/modules/CobrowseWidget/components/CobrowseWidget'

WidgetHelper.reTry('.cobrowseWidget', CobrowseWidget)
